import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Must run before React's own error handler so network errors during
// server cold-start don't surface as red overlay in dev/prod.
window.addEventListener(
  "unhandledrejection",
  function (event) {
    const code = event.reason?.code;
    if (code === "ERR_NETWORK" || code === "ECONNABORTED") {
      event.preventDefault();
    }
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
